export function cleanDesignName(value: string): string {
  const suffix = value.match(/[（(](\d+)[）)]\s*$/)?.[1];
  const base = value.replace(/[（(][^）)]*[）)]/g, '').replace(/[★☆✦♧▶@·•“”"「」『』+＋\-－/／\\]/g, '').trim();
  return `${base}${suffix ? `（${suffix}）` : ''}`;
}

export function uniqueDesignName(value: string, names: string[]): string {
  const base = (cleanDesignName(value) || '新建方案').slice(0, 100);
  const existing = new Set(names.map(name => cleanDesignName(name).toLocaleLowerCase()));
  let name = base, index = 1;
  while (existing.has(name.toLocaleLowerCase())) {
    const suffix = `（${index++}）`;
    name = `${base.slice(0, 100 - suffix.length)}${suffix}`;
  }
  return name;
}

export function generatedDesignName(well: string, type = '智能压裂'): string {
  const name = cleanDesignName(well).replace(/[（(]\d+[）)]$/, '') || '当前井';
  return `${name.endsWith('井') ? name : `${name}井`}${type}方案`;
}
